export enum TableStyle {
    SERVICE = 'SERVICE',
    SUBSERVICE = 'SUBSERVICE',
    TAB = 'TAB',
    TRACKING = 'TRACKING',
    DISPATCH_BALLOT = 'DISPATCH_BALLOT',
    INCIDENCE = 'INCIDENCE',
    SECTOR_MULTIFARE = 'SECTOR_MULTIFARE'
}